import React from "react";

export default function Button({ onClick, text, classes }) {
  return (
    <button
      onClick={onClick}
      className={"rounded-md p-2 text-white p-3 " + classes}
    >
      {text}
    </button>
  );
}
